import { render, staticRenderFns } from "./PivotBarChart.vue?vue&type=template&id=5323c81d&"
import script from "./PivotBarChart.vue?vue&type=script&lang=ts&"
export * from "./PivotBarChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports